/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2020-08-18 17:05:35
 */
import router from "./router";

const getComponent = (page) => {
  return router[page] || router[`P${page}`] || router['pageNull'];
}

export default getComponent;

export {router};


// WEBPACK FOOTER //
// src/routes/customChart/getComponent.js